export class Constants {
    public static urls = {
        start: "/",
        user: "/user",
        template: "/template",
        company: "/company",
    }
}